import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from 'src/environments/environment';
import { CaseTypeResponseModel } from "../../models/case/case-type-response.model";

@Injectable({
	providedIn: 'root'
})
export class OutboundCasesService {
	private subRoute = "outboundCases";
	private httpOptions = { headers: new HttpHeaders({ 'Content-type': 'application/json' }) };

	constructor(private http: HttpClient) {
		this.http = http;
	}

	getCaseByTypeCAndSubdivision(bkCaseTypeC: String, subDivisionUidK: number): Observable<CaseTypeResponseModel> {
		const URL = `${environment.backend_Jab_url}${this.subRoute}/caseType/${bkCaseTypeC}/subdivision/${subDivisionUidK}`;

		return this.http.get<CaseTypeResponseModel>(URL, this.httpOptions);
	}

}
